import VehiclePlaqueMetadataFields from "./VehiclePlaqueMetadataFields";

function VehicleInfoModal({
  plaqueMetadata,
  setPlaqueMetadata,
  isOpen,
  carYear,
  setCarYear,
  carMake,
  setCarMake,
  carModel,
  setCarModel,
  purchaseDate,
  setPurchaseDate,
  carStatus,
  setCarStatus,
  carDetails,
  setCarDetails,
  salePrice,
  setSalePrice,
  saleMileage,
  setSaleMileage,
  saleTitleStatus,
  setSaleTitleStatus,
  salePreferredContact,
  setSalePreferredContact,
  saleClassifiedsLink,
  setSaleClassifiedsLink,
  onSave,
  onCancel
}) {
  if (!isOpen) return null;

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <h2 style={{ marginTop: 0 }}>Vehicle Information</h2>

        <input
          placeholder="Year — example: 1998"
          value={carYear}
          onChange={(e) => setCarYear(e.target.value)}
          style={inputStyle}
        />

        <select
          value={carMake}
          onChange={(e) => setCarMake(e.target.value)}
          style={inputStyle}
        >
          <option value="">Select Make</option>
          {carMakes.map((make) => (
            <option key={make} value={make}>
              {make}
            </option>
          ))}
        </select>

        <input
          placeholder="Model — example: Supra"
          value={carModel}
          onChange={(e) => setCarModel(e.target.value)}
          style={inputStyle}
        />

        <VehiclePlaqueMetadataFields value={plaqueMetadata} onChange={setPlaqueMetadata} />
        <label style={labelStyle}>Vehicle Purchase Date</label>

        <input
          type="date"
          value={purchaseDate}
          onChange={(e) => setPurchaseDate(e.target.value)}
          style={inputStyle}
        />

        <select
          value={carStatus}
          onChange={(e) => setCarStatus(e.target.value)}
          style={inputStyle}
        >
          <option value="Driven">Driven</option>
          <option value="In Progress">In Progress</option>
          <option value="Sold">Sold</option>

          <option value="For Sale">For Sale</option>
        </select>

        <textarea
          placeholder="Vehicle Details"
          value={carDetails}
          onChange={(e) => setCarDetails(e.target.value)}
          style={{ ...inputStyle, height: "100px" }}
        />

        {carStatus === "For Sale" && (
          <div style={saleDetailsBoxStyle}>
            <h3 style={{ marginTop: 0 }}>For Sale Details</h3>

            <input
              placeholder="Price — example: $25,000"
              value={salePrice}
              onChange={(e) => setSalePrice(e.target.value)}
              style={inputStyle}
            />

            <input
              placeholder="Mileage — example: 82,000"
              value={saleMileage}
              onChange={(e) => setSaleMileage(e.target.value)}
              style={inputStyle}
            />

            <input
              placeholder="Title Status — example: Clean title"
              value={saleTitleStatus}
              onChange={(e) => setSaleTitleStatus(e.target.value)}
              style={inputStyle}
            />

            <input
              placeholder="Preferred Contact — example: Instagram @username"
              value={salePreferredContact}
              onChange={(e) => setSalePreferredContact(e.target.value)}
              style={inputStyle}
            />

            <input
              placeholder="Classifieds Link — optional"
              value={saleClassifiedsLink}
              onChange={(e) => setSaleClassifiedsLink(e.target.value)}
              style={inputStyle}
            />
          </div>
        )}

        <div style={buttonRowStyle}>
          <button onClick={onCancel} style={cancelButtonStyle}>
            Cancel
          </button>

          <button onClick={onSave} style={saveButtonStyle}>
            Save Vehicle
          </button>
        </div>
      </div>
    </div>
  );
}

const carMakes = [
  "Acura",
  "Alfa Romeo",
  "Aston Martin",
  "Audi",
  "Bentley",
  "BMW",
  "Bugatti",
  "Cadillac",
  "Chevrolet",
  "Dodge",
  "Ferrari",
  "Ford",
  "Genesis",
  "GMC",
  "Honda",
  "Hyundai",
  "Infiniti",
  "Jaguar",
  "Jeep",
  "Kia",
  "Koenigsegg",
  "Lamborghini",
  "Land Rover",
  "Lexus",
  "Lincoln",
  "Lotus",
  "Lucid",
  "Maserati",
  "Mazda",
  "McLaren",
  "Mercedes-Benz",
  "Mini",
  "Mitsubishi",
  "Nissan",
  "Pagani",
  "Polestar",
  "Porsche",
  "RAM",
  "Rimac",
  "Rolls-Royce",
  "Subaru",
  "Suzuki",
  "Tesla",
  "Toyota",
  "Volkswagen",
  "Volvo",
  "Other"
];

const overlayStyle = {
  position: "fixed",
  inset: 0,
  backgroundColor: "rgba(0,0,0,0.82)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 30000,
  padding: "20px"
};

const modalStyle = {
  backgroundColor: "#181818",
  border: "1px solid #333",
  borderRadius: "20px",
  padding: "22px",
  maxWidth: "420px",
  width: "100%",
  maxHeight: "90vh",
  overflowY: "auto",
  boxSizing: "border-box",
  color: "white",
  display: "flex",
  flexDirection: "column",
  gap: "12px"
};

const inputStyle = {
  padding: "14px",
  borderRadius: "12px",
  border: "1px solid #2a2a2a",
  backgroundColor: "#1c1c1c",
  color: "white",
  boxSizing: "border-box",
  width: "100%"
};

const labelStyle = {
  fontWeight: "bold",
  marginTop: "6px"
};

const saleDetailsBoxStyle = {
  backgroundColor: "#1f1f1f",
  border: "1px solid #2a2a2a",
  borderRadius: "14px",
  padding: "14px",
  display: "flex",
  flexDirection: "column",
  gap: "10px"
};

const buttonRowStyle = {
  display: "flex",
  gap: "10px",
  marginTop: "10px"
};

const cancelButtonStyle = {
  flex: 1,
  backgroundColor: "#333",
  color: "white",
  border: "none",
  borderRadius: "12px",
  padding: "14px",
  fontWeight: "bold",
  cursor: "pointer"
};

const saveButtonStyle = {
  flex: 1,
  backgroundColor: "#e10600",
  color: "white",
  border: "none",
  borderRadius: "12px",
  padding: "14px",
  fontWeight: "bold",
  cursor: "pointer"
};

export default VehicleInfoModal;
